export default __webpack_public_path__ + "2e90b0a4f6db2e09128c921b1bc0b65f.png";